import { useLayoutEffect } from 'react';

/** The nested confirmation owns Escape before the drawer's deferred dismiss layer. */
export function useConfirmationEscape(open: boolean, pending: boolean, onCancel: () => void) {
  useLayoutEffect(() => {
    if (!open) return;
    const onEscape = (event: KeyboardEvent) => {
      if (event.key !== 'Escape' || event.isComposing) return;
      event.preventDefault();
      event.stopPropagation();
      if (!pending) onCancel();
    };
    window.addEventListener('keydown', onEscape, true);
    return () => window.removeEventListener('keydown', onEscape, true);
  }, [open, pending, onCancel]);
}
